import React from 'react';

import { TranslatedMessage } from 'common/components/Intl';

export default class CommitmentText extends React.Component {
  renderAutoShipGreeting(commitmentTextId) {
    return (
      <div className="commitment-details__auto-ship-greeting natural-heading--small">
        <TranslatedMessage
          id={`cart.commitment_text.${commitmentTextId}.title`}
        />
      </div>
    );
  }

  renderCheckoutDisclaimer() {
    const { requiredInstallmentCount, isSubscribed, name } = this.props;
    const MIN_PODS_PER_SUBSCRIPTION = window.gon.minimumSubscriptionItems || 2;
    const commitmentTextId = isSubscribed
      ? 'disclaimer_for_existing_members'
      : 'disclaimer_for_new_members';

    return (
      <div className="commitment-details__checkout-disclaimer">
        {this.renderAutoShipGreeting(commitmentTextId)}

        <p>
          <TranslatedMessage
            id={`cart.commitment_text.${commitmentTextId}.body`}
            values={{
              requiredInstallmentCount,
              name,
              minimumPodsSubscription: MIN_PODS_PER_SUBSCRIPTION,
            }}
          />
        </p>
      </div>
    );
  }

  renderCancellationPolicy() {
    const {
      requiredInstallmentCount,
      cancellationFee,
      name,
      maxQuantity,
    } = this.props;

    return (
      <p className="commitment-details__cancellation-policy">
        <TranslatedMessage
          id={'cart.commitment_text.cancellation_policy_with_installments'}
          values={{
            cancellationFee,
            requiredInstallmentCount,
            maxQuantity,
            name,
          }}
        />
      </p>
    );
  }

  render() {
    return (
      <div className="commitment-details">
        {this.renderCheckoutDisclaimer()}
        {this.renderCancellationPolicy()}
      </div>
    );
  }
}
